import React, { useContext, useState, useEffect } from 'react';
import './Productdisplay.css';
import { ShopContext } from '../../Context/ShopContext';

const Productdisplay = () => {
    const product = JSON.parse(localStorage.getItem("currentProd"));
    const { addToCart } = useContext(ShopContext);
    const [status, setStatus] = useState('idle'); // "idle" | "adding" | "added"
    const [quantity, setQuantity] = useState(1);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const imgUrl = process.env.REACT_APP_ASSET_PATH;
    const isSoldOut = product.quantity === 0;

    const handleAddToCart = () => {
        if (product.quantity < 1) 
            return;
        setStatus('ADDING'); // Start loading
        addToCart(product.id, quantity); 
        
        setTimeout(() => {
            setStatus('ADDED'); // Show "Added"
            setTimeout(() => setStatus('idle'), 1000); // Reset after 2 sec
        }, 1000);
    };

    useEffect(() => {
        if (product.quantity === 0 || quantity > product.quantity) {
            setIsButtonDisabled(true);
        }
        else {
            setIsButtonDisabled(false);
        }
     }, [quantity]);

    return (
        <div className="productdisplay">
            <div className="productdisplay-left">
            <div className="productdisplay-img" style={{ position: 'relative', overflow: 'hidden' }}>
            <img className="productdisplay-main-img" src={imgUrl + product.img} alt="" />
            {isSoldOut && (
                <div style={{
                position: 'absolute', top: 22, right: -28,
                background: '#E24B4A', color: '#fff',
                fontSize: '0.75rem', fontWeight: 500, letterSpacing: '0.06em',
                padding: '6px 40px', transform: 'rotate(35deg)'
                }}>SOLD OUT</div>
            )}
            </div>
            </div>
            <div className="productdisplay-right">
                <h1>{product.name}</h1>
                <div className="productdisplay-right-prices">
                    Price: <div className="productdisplay-right-price-new">${product.price}</div>
                </div>
                <div className="productdisplay-right-description">
                    {product.description}
                </div>
                <div className="productdisplay-right-size">
                    <h1>Size:</h1> 
                    <div className="productdisplay-right-sizes">
                        <div>{product.size}</div>
                    </div>
                </div>

               {/* Quantity Selector */}
               <div className="productdisplay-quantity">
                    <h1>Quantity:</h1>
                    <div className="quantity-controls">
                    <button className="quantity-btn" onClick={() => setQuantity(prev => Math.max(1, prev - 1))}>-</button>
                        <input 
                            type="number" 
                            value={quantity} 
                            readOnly
                            disabled
                            onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))} 
                        />
                        <button disabled={isButtonDisabled} className={isButtonDisabled ? "quantity-btn-disabled" : "quantity-btn"} onClick={() => setQuantity(prev => prev + 1)}>+</button>
                    </div>
                </div>

                <button 
                    onClick={handleAddToCart} 
                    className={isButtonDisabled ? "disabled" : status.toLowerCase()}
                    disabled={status === 'ADDING' || status === 'ADDED' || isButtonDisabled} // Disable while adding/added
                >
                    {isButtonDisabled ? 'SOLD OUT' : (status === 'ADDING' ? 'ADDING...' : status === 'ADDED' ? 'ADDED!' : 'ADD TO CART')}
                </button>
            </div>
        </div>
    );
};

export default Productdisplay;
